export default function Dot2() {
  return (
    <div className="w-c10 h-c18 mt-c-8 flex justify-center items-center">
      <span>.</span>
    </div>
  );
}
